import { useId } from 'react'

interface Props {
  name?: string
  label?: string
  placeholder?: string
  value?: string
  rows?: number
  required?: boolean
  disabled?: boolean
  readOnly?: boolean
  maxLength?: number
  hint?: string
  error?: string
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export function Textarea({
  name,
  label,
  placeholder = '',
  value = '',
  rows = 4,
  required = false,
  disabled = false,
  readOnly = false,
  maxLength,
  hint = '',
  error = '',
  onChange,
}: Props) {
  const id = useId()

  return (
    <div className={`cf-field${error ? ' cf-field--error' : ''}`}>
      {label && (
        <label className='cf-field__label' htmlFor={id}>
          {label}
          {required && (
            <span className='cf-field__required' aria-hidden>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      <textarea
        className='cf-field__textarea'
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        rows={rows}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        maxLength={maxLength}
        aria-describedby={hint || error ? `${id}-hint` : undefined}
        aria-invalid={error ? true : undefined}
        onChange={onChange}
      />
      <div className='cf-field__footer'>
        <span className='cf-field__hint' id={`${id}-hint`}>
          {error || hint}
        </span>
        {maxLength !== undefined && (
          <span className='cf-field__counter'>
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </div>
  )
}
